<template>
  <div>
    <v-container fluid class="pa-0">
      <!-- <material-card icon="mdi-clipboard-text" inline title="View Vehicle Details"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  View Vehicle Details
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="9">
            <v-card-actions>
              <router-link :to="{ name: 'addVehicleDetails', params: {} }" title="Create Vehicle Details">
                <v-btn small class="create-vehicle-button" style="position: absolute;right: 130px;top: 20px;" elevation="1" color="primary">
                  <v-icon left>mdi-plus</v-icon>
                  create Vehicle Details
                </v-btn>
              </router-link>
              <!-- <a @click="$router.back()"> -->
                <router-link :to="{ name: 'vehicleSetting', params: {} }" title="Vehicle Settings">
                <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
                <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                </router-link>
              <!-- </a> -->
            </v-card-actions>
          </v-col>
        </v-row>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <!-- <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title> -->
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="announcments"
          :search="search"
        >
          <template v-slot:item.vehicleRegistrationNumber="{ item }">
            {{ item.vehicleRegistrationNumber || '-' }}
          </template>
          <template v-slot:item.seatingCapacity="{ item }">
            {{ item.seatingCapacity || '-' }}
          </template>
          <template v-slot:item.rcBookNumber="{ item }">
            {{ item.rcBookNumber || '-' }}
          </template>
          <template v-slot:item.rcStartDate="{ item }">
            {{ new Date(item.rcStartDate).toLocaleDateString() }}
          </template>
          <template v-slot:item.rcExpiryDate="{ item }">
            {{ new Date(item.rcExpiryDate).toLocaleDateString() }}
          </template>
          <template v-slot:item.vehicleType="{ item }">
            {{ item.vehicleType || '-' }}
          </template>
          <template v-slot:item.batteryNumber="{ item }">
            {{ item.batteryNumber || '-' }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn x-small class="px-2 ml-1 ma-1" outlined @click.prevent="viewDocuments(item.id)">
              View Docs
            </v-btn>
            <router-link :to="{ name: 'editVehicleDetails', params: { vehicleID: item.id } }">
              <v-btn class="px-2 ml-1 ma-1" color="success" x-small outlined>
                Edit
              </v-btn>
            </router-link>
            <!-- <v-btn color="error" min-width="0" small class="px-2 ml-1 ma-1" v-if="item.isActive === true" @click.prevent="activeDeactive(item.id)">
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
               <v-btn class="px-2 ml-1 ma-1" color="accent" min-width="0" small v-if="item.isActive !== true" @click.prevent="Reactive(item.id)">
                <v-icon small> mdi-restore</v-icon>
              </v-btn> -->
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </v-card>
      <loading-icon :value="isLoading" />
    </v-container>
    <div class="modal" :class="{ 'is-active': enableDocumentModal }">
      <div class="modal-background"></div>

      <form class="modal-card" @submit.prevent="ShowDocuments()">
        <header class="modal-card-head" style="margin-top:90px;">
          <p class="modal-card-title"><strong>View Documents</strong></p>
          <button class="delete" type="button" @click="this.toggleDocumentModal"></button>
        </header>
        <v-data-table
          :footer-props="{
            'items-per-page-options': [5]
          }"
          :items-per-page="10"
          :headers="docsheaders"
          :items="vehicleDocuments"
          :search="search"
        >
          <template v-slot:item.Vehicle_Documents="{ item }">
            <v-btn x-small class="px-2 ml-1 ma-1" color="red" outlined @click.prevent="downloadDocuments(item.urlPath)">
              {{ item.documentType || '-' }}
            </v-btn>
          </template>
        </v-data-table>
      </form>
    </div>
  </div>
</template>

<script>
// import VCardComponent from '@/components/template/VCardComponent'
// import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'vehicleDetails',
  components: {
    // MaterialCard
    //  VCardComponent
  },
  data () {
    return {
      search: '',
      isLoading: false,
      loadingComponent: null,
      academicYears: [],
      academicYearID: '',
      stages: [],
      inProgress: false,
      franchiseeArr: [],
      franchiseeID: '',
      enableDocumentModal: false,
      UserType: '',
      vehicleDocuments: [],
      status: '',
      announcments: [],
      total: '',
      headers: [
        { text: 'Vehicle Number', value: 'vehicleRegistrationNumber', sortable: true },
        { text: 'Seating Capacity', value: 'seatingCapacity', sortable: true },
        { text: 'RC Book Number', value: 'rcBookNumber', sortable: true },
        { text: 'RC Book Start Date', value: 'rcStartDate', sortable: true },
        { text: 'RC Book Expiry Date', value: 'rcExpiryDate', sortable: true },
        { text: 'Vehicle Type', value: 'vehicleType', sortable: true },
        { text: 'Battery Number', value: 'batteryNumber', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ],
      docsheaders: [{ text: 'Vehicle Documents', value: 'Vehicle_Documents', sortable: true }]
    }
  },
  async created () {
    await this.getYear()
    await this.getFranchiseeList()
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.Save()
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    viewDocuments: async function (ID) {
      this.toggleDocumentModal()
      let response = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails/document/${ID}`)
      this.vehicleDocuments = response.data
    },
    downloadDocuments: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    toggleDocumentModal: function () {
      this.enableDocumentModal = !this.enableDocumentModal
    },
    Save: async function () {
      this.announcments = []
      this.total = ''
      try {
        let getParam = {}
        if (this.franchiseeID.length === 0) {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          getParam.franchiseeID = this.franchiseeID
        }
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails`, {
          params: getParam
        })

        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.announcments = data
          this.total = this.announcments.length
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    }
  }
}
</script>
